import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from "@angular/material";

import { routerAnimation } from './app.animations'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routerAnimation()]
})
export class AppComponent {
  public constructor (
    public matIconRegistry: MatIconRegistry
  ) {
    //add custom material icons
    matIconRegistry.registerFontClassAlias ('fontawesome','fa');
  }
  getRouteAnimation( outlet: any ) {
      return outlet.activatedRouteData.animation;
  }
}



// WEBPACK FOOTER //
// C:/Users/cmcever/Documents/GitHub/ChallengerTurf/EPSePortal/src/app/app.component.ts